module.exports = __webpack_public_path__ + "components/breakheader/static/get_alerts--temp-5ab9c9062afb7fa71e9c9c8294216256.gif";